import { useMemo } from "react"

import { buildSearchIndex, searchDocs } from "features/Docs/utils/searchIndex"
import { DocsContentMap } from "features/Docs/hooks/useDocsContent"
import { SearchRecord, SearchResult } from "features/Docs/types/docs.types"

interface UseDocsSearch {
  index: SearchRecord[]
  search: (query: string) => SearchResult[]
}

/**
 * Build the search index once from the loaded content and expose a memoised
 * search function over it.
 */
export const useDocsSearch = (
  content: DocsContentMap | undefined,
): UseDocsSearch => {
  const index = useMemo(
    () => (content ? buildSearchIndex(content) : []),
    [content],
  )

  const search = useMemo(
    () => (query: string): SearchResult[] => searchDocs(index, query),
    [index],
  )

  return { index, search }
}
